// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><defs><pattern id=\"grain\" width=\"100\" height=\"100\" patternUnits=\"userSpaceOnUse\"><circle cx=\"25\" cy=\"25\" r=\"1\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"75\" cy=\"75\" r=\"1\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"50\" cy=\"10\" r=\"0.5\" fill=\"white\" opacity=\"0.1\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url%28%23grain%29\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AnnouncementModal_overlay__f6HfW {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  opacity: 0;
  transition: opacity 0.3s ease;
  padding: 20px;
}
.AnnouncementModal_overlay__f6HfW.AnnouncementModal_visible__-P1gg {
  opacity: 1;
}

.AnnouncementModal_modal__ieeJz {
  background: white;
  border-radius: 24px;
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(255, 255, 255, 0.1);
  transform: scale(0.9) translateY(20px);
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.AnnouncementModal_modal__ieeJz.AnnouncementModal_visible__-P1gg {
  transform: scale(1) translateY(0);
}

.AnnouncementModal_header__GxUhj {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 32px;
  border-radius: 24px 24px 0 0;
  position: relative;
  overflow: hidden;
}
.AnnouncementModal_header__GxUhj::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  opacity: 0.3;
}

.AnnouncementModal_headerContent__FSJOP {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  z-index: 1;
}

.AnnouncementModal_logo__MgwnR {
  display: flex;
  align-items: center;
  gap: 16px;
}
.AnnouncementModal_logo__MgwnR h2 {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.AnnouncementModal_logoIcon__CbzF\\+ {
  font-size: 48px;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
}

.AnnouncementModal_closeButton__CmxQu {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 24px;
  color: white;
  transition: all 0.3s ease;
}
.AnnouncementModal_closeButton__CmxQu:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.AnnouncementModal_version__\\+ZUXS {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
  position: relative;
  z-index: 1;
}

.AnnouncementModal_versionBadge__R1NeJ {
  background: rgba(255, 255, 255, 0.2);
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.AnnouncementModal_versionText__k5ABk {
  font-size: 16px;
  opacity: 0.9;
}

.AnnouncementModal_content__s-nEj {
  padding: 40px;
}

.AnnouncementModal_welcome__Js-GR {
  text-align: center;
  margin-bottom: 40px;
}
.AnnouncementModal_welcome__Js-GR h3 {
  margin: 0 0 16px 0;
  font-size: 24px;
  color: #1f2937;
  font-weight: 700;
}
.AnnouncementModal_welcome__Js-GR p {
  margin: 0;
  font-size: 16px;
  color: #6b7280;
  line-height: 1.6;
}

.AnnouncementModal_features__m44aB {
  margin-bottom: 40px;
}
.AnnouncementModal_features__m44aB h4 {
  margin: 0 0 24px 0;
  font-size: 20px;
  color: #1f2937;
  font-weight: 600;
}

.AnnouncementModal_featureGrid__dC6tm {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 20px;
}

.AnnouncementModal_featureCard__feoO8 {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 2px solid var(--accent-color, #3b82f6);
  border-radius: 16px;
  padding: 24px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.AnnouncementModal_featureCard__feoO8::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--accent-color, #3b82f6);
}
.AnnouncementModal_featureCard__feoO8:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
}

.AnnouncementModal_featureHeader__buiAX {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 16px;
}

.AnnouncementModal_featureIcon__cHL22 {
  font-size: 32px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.AnnouncementModal_featureTitle__B1ibh {
  flex: 1 1;
}
.AnnouncementModal_featureTitle__B1ibh h5 {
  margin: 0 0 8px 0;
  font-size: 18px;
  color: #1f2937;
  font-weight: 600;
}

.AnnouncementModal_featureHighlight__ldBdm {
  background: var(--accent-color, #3b82f6);
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.AnnouncementModal_featureDescription__MTeZ- {
  margin: 0;
  font-size: 14px;
  color: #4b5563;
  line-height: 1.6;
}

.AnnouncementModal_quickStart__Xgr8r {
  margin-bottom: 40px;
}
.AnnouncementModal_quickStart__Xgr8r h4 {
  margin: 0 0 24px 0;
  font-size: 20px;
  color: #1f2937;
  font-weight: 600;
}

.AnnouncementModal_steps__\\+DJ9b {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.AnnouncementModal_step__1yScJ {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: linear-gradient(135deg, #fef3e2 0%, #fed7aa 100%);
  border-radius: 12px;
  border: 1px solid rgba(251, 146, 60, 0.2);
}

.AnnouncementModal_stepNumber__p1qNa {
  background: #f59e0b;
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  flex-shrink: 0;
}

.AnnouncementModal_stepContent__YzcpT {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1;
}

.AnnouncementModal_stepIcon__ZDn8- {
  font-size: 16px;
}

.AnnouncementModal_stepText__ur-wn {
  font-size: 14px;
  color: #92400e;
  font-weight: 500;
}

.AnnouncementModal_highlights__Yh-3G {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
  margin-bottom: 32px;
}

.AnnouncementModal_highlight__DGImH {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
}

.AnnouncementModal_highlightIcon__tyl7o {
  font-size: 24px;
}

.AnnouncementModal_highlightContent__GbOuv {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.AnnouncementModal_highlightContent__GbOuv strong {
  font-size: 14px;
  color: #1f2937;
  font-weight: 600;
}
.AnnouncementModal_highlightContent__GbOuv span {
  font-size: 12px;
  color: #6b7280;
}

.AnnouncementModal_contentActions__XfUP2 {
  text-align: center;
  margin-bottom: 40px;
}

.AnnouncementModal_footerInfo__vir61 {
  margin-top: 16px;
  font-size: 14px;
  color: #6b7280;
}

.AnnouncementModal_startButton__7TSmn {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 16px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}
.AnnouncementModal_startButton__7TSmn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(59, 130, 246, 0.4);
}
.AnnouncementModal_startButton__7TSmn:active {
  transform: translateY(0);
}

.AnnouncementModal_footer__GBRDA {
  background: #f9fafb;
  padding: 32px 40px;
  border-radius: 0 0 24px 24px;
  border-top: 1px solid #e5e7eb;
}

.AnnouncementModal_footerContent__z0WT0 {
  text-align: center;
}

@media (max-width: 768px) {
  .AnnouncementModal_modal__ieeJz {
    margin: 10px;
    max-height: 95vh;
  }
  .AnnouncementModal_header__GxUhj {
    padding: 24px;
  }
  .AnnouncementModal_logo__MgwnR h2 {
    font-size: 22px;
  }
  .AnnouncementModal_logoIcon__CbzF\\+ {
    font-size: 36px;
  }
  .AnnouncementModal_content__s-nEj {
    padding: 24px;
  }
  .AnnouncementModal_featureGrid__dC6tm {
    grid-template-columns: 1fr;
  }
  .AnnouncementModal_steps__\\+DJ9b {
    grid-template-columns: 1fr;
  }
  .AnnouncementModal_highlights__Yh-3G {
    grid-template-columns: 1fr;
  }
  .AnnouncementModal_footer__GBRDA {
    padding: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AnnouncementModal/index.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,UAAA;EACA,6BAAA;EACA,aAAA;AACF;AACE;EACE,UAAA;AACJ;;AAGA;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,+EACE;EAEF,sCAAA;EACA,sDAAA;AAFF;AAIE;EACE,iCAAA;AAFJ;;AAMA;EACE,6DAAA;EACA,YAAA;EACA,aAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;AAHF;AAKE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,mDAAA;EACA,YAAA;AAHJ;;AAOA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAJF;AAME;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,yCAAA;AAJJ;;AAQA;EACE,eAAA;EACA,iDAAA;AALF;;AAQA;EACE,oCAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;AALF;AAOE;EACE,oCAAA;EACA,qBAAA;AALJ;;AASA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AANF;;AASA;EACE,oCAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,0CAAA;AANF;;AASA;EACE,eAAA;EACA,YAAA;AANF;;AASA;EACE,aAAA;AANF;;AASA;EACE,kBAAA;EACA,mBAAA;AANF;AAQE;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AANJ;AASE;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAPJ;;AAWA;EACE,mBAAA;AARF;AAUE;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AARJ;;AAYA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AATF;;AAYA;EACE,6DAAA;EACA,8CAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AATF;AAWE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,wCAAA;AATJ;AAYE;EACE,2BAAA;EACA,0CAAA;AAVJ;;AAcA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAXF;;AAcA;EACE,eAAA;EACA,iDAAA;AAXF;;AAcA;EACE,SAAA;AAXF;AAaE;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAXJ;;AAeA;EACE,wCAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAZF;;AAeA;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAZF;;AAeA;EACE,mBAAA;AAZF;AAcE;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAZJ;;AAgBA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,6DAAA;EACA,mBAAA;EACA,yCAAA;AAbF;;AAgBA;EACE,mBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;AAbF;;AAgBA;EACE,eAAA;AAbF;;AAgBA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAbF;;AAgBA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,eAAA;AAbF;;AAgBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAbF;AAeE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAbJ;AAgBE;EACE,eAAA;EACA,cAAA;AAdJ;;AAkBA;EACE,kBAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAfF;;AAkBA;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,8CAAA;AAfF;AAiBE;EACE,2BAAA;EACA,8CAAA;AAfJ;AAkBE;EACE,wBAAA;AAhBJ;;AAoBA;EACE,mBAAA;EACA,kBAAA;EACA,4BAAA;EACA,6BAAA;AAjBF;;AAoBA;EACE,kBAAA;AAjBF;;AAqBA;EACE;IACE,YAAA;IACA,gBAAA;EAlBF;EAqBA;IACE,aAAA;EAnBF;EAsBA;IACE,eAAA;EApBF;EAuBA;IACE,eAAA;EArBF;EAwBA;IACE,aAAA;EAtBF;EAyBA;IACE,0BAAA;EAvBF;EA0BA;IACE,0BAAA;EAxBF;EA2BA;IACE,0BAAA;EAzBF;EA4BA;IACE,aAAA;EA1BF;AACF","sourcesContent":[".overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  padding: 20px;\n\n  &.visible {\n    opacity: 1;\n  }\n}\n\n.modal {\n  background: white;\n  border-radius: 24px;\n  max-width: 900px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: \n    0 25px 50px rgba(0, 0, 0, 0.25),\n    0 0 0 1px rgba(255, 255, 255, 0.1);\n  transform: scale(0.9) translateY(20px);\n  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n\n  &.visible {\n    transform: scale(1) translateY(0);\n  }\n}\n\n.header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 32px;\n  border-radius: 24px 24px 0 0;\n  position: relative;\n  overflow: hidden;\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><defs><pattern id=\"grain\" width=\"100\" height=\"100\" patternUnits=\"userSpaceOnUse\"><circle cx=\"25\" cy=\"25\" r=\"1\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"75\" cy=\"75\" r=\"1\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"50\" cy=\"10\" r=\"0.5\" fill=\"white\" opacity=\"0.1\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url(%23grain)\"/></svg>');\n    opacity: 0.3;\n  }\n}\n\n.headerContent {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  position: relative;\n  z-index: 1;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n\n  h2 {\n    margin: 0;\n    font-size: 28px;\n    font-weight: 700;\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  }\n}\n\n.logoIcon {\n  font-size: 48px;\n  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));\n}\n\n.closeButton {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 24px;\n  color: white;\n  transition: all 0.3s ease;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.3);\n    transform: scale(1.1);\n  }\n}\n\n.version {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 16px;\n  position: relative;\n  z-index: 1;\n}\n\n.versionBadge {\n  background: rgba(255, 255, 255, 0.2);\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 600;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.versionText {\n  font-size: 16px;\n  opacity: 0.9;\n}\n\n.content {\n  padding: 40px;\n}\n\n.welcome {\n  text-align: center;\n  margin-bottom: 40px;\n\n  h3 {\n    margin: 0 0 16px 0;\n    font-size: 24px;\n    color: #1f2937;\n    font-weight: 700;\n  }\n\n  p {\n    margin: 0;\n    font-size: 16px;\n    color: #6b7280;\n    line-height: 1.6;\n  }\n}\n\n.features {\n  margin-bottom: 40px;\n\n  h4 {\n    margin: 0 0 24px 0;\n    font-size: 20px;\n    color: #1f2937;\n    font-weight: 600;\n  }\n}\n\n.featureGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: 20px;\n}\n\n.featureCard {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border: 2px solid var(--accent-color, #3b82f6);\n  border-radius: 16px;\n  padding: 24px;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 4px;\n    background: var(--accent-color, #3b82f6);\n  }\n\n  &:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);\n  }\n}\n\n.featureHeader {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.featureIcon {\n  font-size: 32px;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));\n}\n\n.featureTitle {\n  flex: 1;\n\n  h5 {\n    margin: 0 0 8px 0;\n    font-size: 18px;\n    color: #1f2937;\n    font-weight: 600;\n  }\n}\n\n.featureHighlight {\n  background: var(--accent-color, #3b82f6);\n  color: white;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.featureDescription {\n  margin: 0;\n  font-size: 14px;\n  color: #4b5563;\n  line-height: 1.6;\n}\n\n.quickStart {\n  margin-bottom: 40px;\n\n  h4 {\n    margin: 0 0 24px 0;\n    font-size: 20px;\n    color: #1f2937;\n    font-weight: 600;\n  }\n}\n\n.steps {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n}\n\n.step {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px;\n  background: linear-gradient(135deg, #fef3e2 0%, #fed7aa 100%);\n  border-radius: 12px;\n  border: 1px solid rgba(251, 146, 60, 0.2);\n}\n\n.stepNumber {\n  background: #f59e0b;\n  color: white;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n.stepContent {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n}\n\n.stepIcon {\n  font-size: 16px;\n}\n\n.stepText {\n  font-size: 14px;\n  color: #92400e;\n  font-weight: 500;\n}\n\n.highlights {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 16px;\n  margin-bottom: 32px;\n}\n\n.highlight {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n}\n\n.highlightIcon {\n  font-size: 24px;\n}\n\n.highlightContent {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n\n  strong {\n    font-size: 14px;\n    color: #1f2937;\n    font-weight: 600;\n  }\n\n  span {\n    font-size: 12px;\n    color: #6b7280;\n  }\n}\n\n.contentActions {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.footerInfo {\n  margin-top: 16px;\n  font-size: 14px;\n  color: #6b7280;\n}\n\n.startButton {\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  padding: 16px 32px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 20px rgba(59, 130, 246, 0.4);\n  }\n\n  &:active {\n    transform: translateY(0);\n  }\n}\n\n.footer {\n  background: #f9fafb;\n  padding: 32px 40px;\n  border-radius: 0 0 24px 24px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.footerContent {\n  text-align: center;\n}\n\n// 响应式设计\n@media (max-width: 768px) {\n  .modal {\n    margin: 10px;\n    max-height: 95vh;\n  }\n\n  .header {\n    padding: 24px;\n  }\n\n  .logo h2 {\n    font-size: 22px;\n  }\n\n  .logoIcon {\n    font-size: 36px;\n  }\n\n  .content {\n    padding: 24px;\n  }\n\n  .featureGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .steps {\n    grid-template-columns: 1fr;\n  }\n\n  .highlights {\n    grid-template-columns: 1fr;\n  }\n\n  .footer {\n    padding: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `AnnouncementModal_overlay__f6HfW`,
	"visible": `AnnouncementModal_visible__-P1gg`,
	"modal": `AnnouncementModal_modal__ieeJz`,
	"header": `AnnouncementModal_header__GxUhj`,
	"headerContent": `AnnouncementModal_headerContent__FSJOP`,
	"logo": `AnnouncementModal_logo__MgwnR`,
	"logoIcon": `AnnouncementModal_logoIcon__CbzF+`,
	"closeButton": `AnnouncementModal_closeButton__CmxQu`,
	"version": `AnnouncementModal_version__+ZUXS`,
	"versionBadge": `AnnouncementModal_versionBadge__R1NeJ`,
	"versionText": `AnnouncementModal_versionText__k5ABk`,
	"content": `AnnouncementModal_content__s-nEj`,
	"welcome": `AnnouncementModal_welcome__Js-GR`,
	"features": `AnnouncementModal_features__m44aB`,
	"featureGrid": `AnnouncementModal_featureGrid__dC6tm`,
	"featureCard": `AnnouncementModal_featureCard__feoO8`,
	"featureHeader": `AnnouncementModal_featureHeader__buiAX`,
	"featureIcon": `AnnouncementModal_featureIcon__cHL22`,
	"featureTitle": `AnnouncementModal_featureTitle__B1ibh`,
	"featureHighlight": `AnnouncementModal_featureHighlight__ldBdm`,
	"featureDescription": `AnnouncementModal_featureDescription__MTeZ-`,
	"quickStart": `AnnouncementModal_quickStart__Xgr8r`,
	"steps": `AnnouncementModal_steps__+DJ9b`,
	"step": `AnnouncementModal_step__1yScJ`,
	"stepNumber": `AnnouncementModal_stepNumber__p1qNa`,
	"stepContent": `AnnouncementModal_stepContent__YzcpT`,
	"stepIcon": `AnnouncementModal_stepIcon__ZDn8-`,
	"stepText": `AnnouncementModal_stepText__ur-wn`,
	"highlights": `AnnouncementModal_highlights__Yh-3G`,
	"highlight": `AnnouncementModal_highlight__DGImH`,
	"highlightIcon": `AnnouncementModal_highlightIcon__tyl7o`,
	"highlightContent": `AnnouncementModal_highlightContent__GbOuv`,
	"contentActions": `AnnouncementModal_contentActions__XfUP2`,
	"footerInfo": `AnnouncementModal_footerInfo__vir61`,
	"startButton": `AnnouncementModal_startButton__7TSmn`,
	"footer": `AnnouncementModal_footer__GBRDA`,
	"footerContent": `AnnouncementModal_footerContent__z0WT0`
};
export default ___CSS_LOADER_EXPORT___;
